var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:[
    'BaseLoader',
    ('BaseLoader-' + _vm.color),
    ('BaseLoader-' + _vm.size),
    { 'BaseLoader-float': _vm.float }
  ]})
}
var staticRenderFns = []

export { render, staticRenderFns }